export default __webpack_public_path__ + "static/media/offer-icon-expired.dd8d010b.svg";